import React from 'react';
import { signerFormInputs } from './signerFormInputs';
import { prepareInput } from '../../../Input';

class SiteReg extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      lastName: '',
      patronymic: '',
      companyPosition: '',
      basis: '',
      inputs: signerFormInputs,
    };
  }

  validateInput = name => {
    const { inputs } = this.state;
    const currentInputIndex = inputs.findIndex(input => input.name === name);
    const currentInput = inputs[currentInputIndex];
    const isValid = currentInput.validator(this.state[currentInput.name]);
    if (!isValid !== currentInput.error) {
      const newInputs = inputs.slice(0);
      newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
      this.setState({ inputs: newInputs });
    }
  };

  filterInputsByName = (inputNames) => {
    const newInputs = this.state.inputs.filter((inp) => {
      let shouldBeFiltered = false;
      inputNames.map((name) => {
        if(inp.name === name) shouldBeFiltered = true;
        return false;
      });
      return !shouldBeFiltered;
    });

    return newInputs;
  }

  changeInput = (name, val) => {
    const newState = this.state;
    const currentInput = this.state.inputs.find((inp) => inp.name === name);

    if(currentInput.type === 'select'){
      const pickedOption = currentInput.options.find(opt => opt.value === val);

      const extraFieldsName = [];

      currentInput.options.map(opt => {
        if(opt.fields) {
          opt.fields.map((field) => {
            extraFieldsName.push(field.name);
            return false;
          });
        }
        return false;
      });

      extraFieldsName.map((field) => {
        newState[field] = '';
        return false;
      });

      newState.inputs = pickedOption.fields 
        ? [...this.filterInputsByName(extraFieldsName), ...pickedOption.fields] 
        : this.filterInputsByName(extraFieldsName);
    }

    newState[name] = val;
    this.setState(newState);
  };

  getData = () => {
    const data = { ...this.state };
    delete data.inputs;
    return data;
  };

  validateForm = () => {
    const { inputs } = this.state;
    const newInputs = inputs.slice(0);

    let isValidationPassed = true;
    newInputs.forEach((input, index) => {
      const isValid = input.validator(this.state[input.name]);
      isValidationPassed = isValidationPassed && isValid;
      if (!isValid !== input.error) {
        newInputs[index] = { ...input, error: !isValid };
      }
    });

    this.setState({ inputs: newInputs });
    return isValidationPassed;
  };

  render() {
    const { inputs } = this.state;

    return (
      <div className="registration__form">
        <div className="inp-wrap">
          {inputs?.map(input =>
            prepareInput({
              ...input,
              value: this.state[input.name],
              onChangeCallback: this.changeInput,
              onBlurCallback: this.validateInput,
            }),
          )}
        </div>
      </div>
    );
  }
}

export default SiteReg;
